import { render, staticRenderFns } from "./UpdateScreeningPoster.vue?vue&type=template&id=e4ba9a58&"
import script from "./UpdateScreeningPoster.vue?vue&type=script&lang=js&"
export * from "./UpdateScreeningPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports